module.exports = __webpack_public_path__ + "assets/suitcase-77bfd550f729aca79b296f57610ef686.svg";